import { SizePassportSelection } from '@susu/custom-made/utils/interfaces';
import { createContext } from 'react';

type SizePassportContextType = {
  token?: string;
  setToken: (token: string) => void;
  tokenInjectionFailed: boolean;
  setTokenInjectionFailed: (failed: boolean) => void;
  sizePassportSelection: SizePassportSelection;
  setSizePassportSelection: (sizePassportSelection: SizePassportSelection) => void;
  spCorrelationId?: string;
  setSpCorrelationId: (spCorrelationId: string) => void;
};

const defaultSizePassportContext: SizePassportContextType = {
  token: undefined,
  setToken: () => {},
  tokenInjectionFailed: false,
  setTokenInjectionFailed: () => {},
  sizePassportSelection: {},
  setSizePassportSelection: () => {},
  spCorrelationId: crypto.randomUUID(),
  setSpCorrelationId: () => {},
};

export const SizePassportContext = createContext<SizePassportContextType>(defaultSizePassportContext);
